'use client';

import React from 'react';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { Wrapper } from './styles';
import { TestimonialCard } from './TestimonialCard/TestimonialCard';
import { TestimonialProps } from './types';

export const Testimonial: React.FC<TestimonialProps> = ({ cards }) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        <Wrapper>
          {cards.map((card) => (
            <TestimonialCard
              key={card.name}
              image={card.image}
              name={card.name}
              subscribersText={card.subscribersText}
              title={card.title}
            />
          ))}
        </Wrapper>
      </ComponentContainer>
    </ComponentWrapper>
  );
};
